import React, { useEffect, useState, useCallback } from 'react';
import getConfig from 'next/config';
import { setHeightForWidget } from '../../utilities';

function FdpqWidget({
    zipCode,
    pageName, /* `pageName` is only used for analytics. */
    isKbb,
    listingType = 'new',
    franchiseId,
    isXs,
    siteSection,
    pageType,
}) {
    const [isClient, setIsClient] = useState(false);
    const [src, setSrc] = useState('');
    const [iframeHeight, setIframeHeight] = useState(isXs ? 378 : 287);

    const sendMessageEvent = useCallback((event) => {
        const calculatedHeight = setHeightForWidget(event, document);
        if (calculatedHeight) {
            setIframeHeight(calculatedHeight);
        }
    }, []);

    useEffect(() => {
        const { publicRuntimeConfig } = getConfig();
        const { fdpqUrl, fdpqAtcKey, fdpqKbbKey } = publicRuntimeConfig;

        const apiKey = isKbb ? fdpqKbbKey : fdpqAtcKey;
        const urlPath = isKbb ? '/kbb/index.html' : '/atc/index.html';
        const baseUrl = `${fdpqUrl}${urlPath}?apikey=${apiKey}`;

        const params = {
            zipCode,
            pageName,
            vehicleListingType: listingType,
            leadPartnerFranchiseId: franchiseId,
            origin: global?.origin,
            pagetype: siteSection,
            pageid: pageType,
        };
        const searchParams = new URLSearchParams(params);
        setSrc(`${baseUrl}&${searchParams}`);
        setIsClient(true);
    }, [
        franchiseId,
        isKbb,
        listingType,
        pageName,
        pageType,
        siteSection,
        zipCode,
    ]);

    useEffect(() => {
        window.addEventListener('message', sendMessageEvent);
        return () => window.removeEventListener('message', sendMessageEvent);
    }, [sendMessageEvent, franchiseId]);

    return isClient ? (
        <iframe
            title="New Car Price Quote"
            id="fdpq-iframe"
            src={src}
            frameBorder="0"
            width="100%"
            height={iframeHeight}
            loading="lazy"
        />
    ) : null;
}

export default React.memo(FdpqWidget);
